import classnames from 'classnames';
import React from 'react';

import { type RoundButtonProps } from './types';

export default function RoundButton({
  children,
  url,
  variant = 'primary',
  size = 'medium',
  className,
  ...props
}: RoundButtonProps) {
  const content = children;

  if (!content) return null;

  const buttonClasses = classnames(
    'round-button',
    `button--${variant}`,
    `round-button--${size}`,
    className,
  );

  if (url) {
    return (
      <a
        href={url}
        className={buttonClasses}
        {...(props as React.AnchorHTMLAttributes<HTMLAnchorElement>)}
      >
        {content}
      </a>
    );
  }

  return (
    <button
      type="button"
      className={buttonClasses}
      {...(props as React.ButtonHTMLAttributes<HTMLButtonElement>)}
    >
      {content}
    </button>
  );
}
